import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LOGIN_STATUS, STORAGE_KEY } from "../../utils/Constant";
import { LoggedUserType } from "../../models/GlobalModels";
import { LoginInitialState } from "../../models/LoginModels";
import { clearSession, getFromLocalStorage, removeFromLocalStorage, saveInLocalStorage } from "../../utils/Util";
import { LoginV, logout, onPostSSOLogin, registeredEmp } from "../../services";
import { getAccessedStatesnDistricts } from "../../utils/AuthUtils";

const blankUser: LoggedUserType = {
  accessToken: "",
  accessExpiryTime: "",
  candidateUniqueId: "",
  employeeName: "",
  emailId: "",
  permissions: [],
  resetToken: "",
  resetExpiryTime: "",
  roleId: -1,
  roleName: [],
  sessionId: "",
  userId: "",
  accessedStates: [],
  accessedDistricts: [],
};
export const initialState: LoginInitialState = {
  status: LOGIN_STATUS.NO_AUTHENTICATED,
  user: blankUser,
};

export const getRegisteredEmployees = createAsyncThunk("dummyAPI", async () => {
  const res = await registeredEmp({});
  return res.data;
});
export const postSSOLogin = createAsyncThunk(
  "update/postLogin",
  async (data: any) => {
    const res = await onPostSSOLogin(data);
    return res.data;
  }
);
export const onLogout = createAsyncThunk("update/logout", async () => {
  const res = await logout();
  return res.data;
});
export const itusLogin = createAsyncThunk("itus/logiv", async (data: any) => {
  const res = await LoginV(data);
  return res.data;
});
export const fetchAndUpdateAccessedStatesAndDistricts = createAsyncThunk(
  "login/fetchAccessedStatesAndDistricts",
  async (_, { getState }) => {
    const state = getState() as any;
    const user = state.login.user;
    
    if (!user.userId || !user.accessToken) {
      throw new Error("User not authenticated");
    }
    
    const { accessedStates, accessedDistricts } = await getAccessedStatesnDistricts(user.userId, user.accessToken);
    return { accessedStates, accessedDistricts };
  }
);
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setAuthenticated: (state: LoginInitialState, action) => {
      state.status = action.payload.status;
      state.user = action.payload.user;
      saveInLocalStorage(
        STORAGE_KEY.AUTH_DATA,
        JSON.stringify(action.payload.user)
      );
    },
    setLocalLogout: (state:LoginInitialState, action) => {
      state.status = LOGIN_STATUS.NO_AUTHENTICATED;
      state.user = blankUser;
      removeFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      removeFromLocalStorage(STORAGE_KEY.ITUS);
      clearSession();
    },
    checkAuthenticated: (state: LoginInitialState, action) => {
      const data = getFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      if (data) {
        const sessionData: LoggedUserType = JSON.parse(data);
        if (sessionData && sessionData.accessToken) {
          state.status = LOGIN_STATUS.AUTHENTICATED;
          state.user = sessionData;
        }
      }
    },
    updateAccessedStatesAndDistricts: (state: LoginInitialState, action) => {
      state.user.accessedStates = action.payload.accessedStates;
      state.user.accessedDistricts = action.payload.accessedDistricts;
      // Update localStorage as well
      const updatedUser = { ...state.user };
      saveInLocalStorage(
        STORAGE_KEY.AUTH_DATA,
        JSON.stringify(updatedUser)
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getRegisteredEmployees.fulfilled, (state: LoginInitialState, action) => {
        state.status = LOGIN_STATUS.AUTHENTICATED;
      })
      .addCase(itusLogin.fulfilled, (state: LoginInitialState, action) => {
        if (action && action.payload && action.payload.token) {
          saveInLocalStorage(STORAGE_KEY.ITUS, action.payload.token);
        }
      })
      .addCase(fetchAndUpdateAccessedStatesAndDistricts.fulfilled, (state: LoginInitialState, action) => {
        state.user.accessedStates = action.payload.accessedStates;
        state.user.accessedDistricts = action.payload.accessedDistricts;
        // Update localStorage as well
        const updatedUser = { ...state.user };
        saveInLocalStorage(
          STORAGE_KEY.AUTH_DATA,
          JSON.stringify(updatedUser)
        );
      });
  },
});
export const loginSelector = (state: any) => state.login;
export const { setAuthenticated, setLocalLogout, checkAuthenticated, updateAccessedStatesAndDistricts } =
  loginSlice.actions;
export default loginSlice.reducer;
